import { Button, Stack } from '@chakra-ui/react'
import React from 'react'
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom'

const Dashboard = () => {
  const {currentUser} = useSelector((state)=>state.user);
  console.log(currentUser.user.role)

  return (
    <Stack direction={['column','row']} spacing={8} w={'full'} mt={['20vh','25vh']}  h={'70vh'} justifyContent={'center'} alignItems={'center'}>
    {currentUser.user.role==="admin"?(
       <Link to="/teacher-data">
       <Button variant={'solid'} px={20} rounded={'full'} py={8} colorScheme={'orange'}>Teacher's Data</Button>
       </Link>
    ):(<></>)}
   
    <Link to="/student-data">
    <Button variant={'solid'}  rounded={'full'} px={20} py={8} colorScheme={'orange'}>Student's Data</Button>
    </Link>
    <Link to="/admission">
    <Button variant={'solid'}  rounded={'full'} px={20} py={8} colorScheme={'orange'}>Admission</Button>
    </Link>
        </Stack>
  )
}

export default Dashboard
